
export const cobroReducer = (state = [], action) => {

    switch (action.type) {
        case '[COBRO] Load list':
            return {
                ...state,
                cobros: action.payload
            }

        case '[COBRO] set detail':
            return {
                ...state,
                detailCobro: action.payload
            }

        default:
            return state
    }


}